/**
 * The small pill of a count shown beside a tab label. Hidden at zero, so an
 * empty tab reads as a plain label rather than a "0".
 *
 * The four older manager list pages each carry their own inline copy of this;
 * they can migrate here when they are next touched.
 */
export function CountBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span className="ml-2 inline-flex items-center justify-center rounded-full bg-neutral-100 px-2 text-caption-bold font-caption-bold text-neutral-700">
      {count}
    </span>
  );
}

export default CountBadge;
